export default __webpack_public_path__ + "static/media/one_month@2x.32c293c3.png";